export const defaults = {
  pinCodeLength: 4,
  smsCodeLength: 6,
  partialListSizeWithButton: 5,
  partialListSizeWithScroll: 20,
  sizeOfBottomBar: 5,
  maxLoginLength: 16,
  newsPageSize: 8,
  locality: {
    id: 4,
    name: 'Мурманск',
    oktmo: '47701000001',
    geolocation: [68.970663, 33.074918],
  },
};
